import { createContext, useContext } from 'react';
import { AuthContextType } from '../types/AuthTypes';

export const AuthAppContext = createContext<AuthContextType | undefined>(undefined);

export const useAuthAppContext = (): AuthContextType => {
  const context = useContext(AuthAppContext);
  if (!context) {
    throw new Error('useAuthContext must be used within AuthProvider');
  }
  return context;
};
